import React, { useEffect, useState } from "react";
import { getBlocklist, addBlock, deleteBlock } from "../../lib/api";
import { useToast } from "../../hooks/use-toast";
import { X, Ban, Trash2, Building2, Globe, Plus } from "lucide-react";

// Do-Not-Contact manager: block companies (by name) or domains.
export default function BlocklistModal({ open, onClose, onChange }) {
  const { toast } = useToast();
  const [items, setItems] = useState([]);
  const [value, setValue] = useState("");
  const [type, setType] = useState("company");

  const load = () => getBlocklist().then((d) => { setItems(d); onChange && onChange(d.length); }).catch(() => {});
  useEffect(() => { if (open) load(); /* eslint-disable-next-line */ }, [open]);

  if (!open) return null;

  const add = async () => {
    if (!value.trim()) return;
    try {
      await addBlock(value.trim(), type);
      setValue("");
      load();
      toast({ title: "Added to Do-Not-Contact" });
    } catch (e) { toast({ title: "Could not add", variant: "destructive" }); }
  };
  const remove = async (id) => { await deleteBlock(id); load(); };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-2xl border border-border w-full max-w-lg p-6 shadow-2xl">
        <div className="flex items-center justify-between mb-1">
          <h3 className="font-display text-[18px] font-semibold text-foreground flex items-center gap-2"><Ban size={17} className="text-red-500" /> Do-Not-Contact list</h3>
          <button onClick={onClose} className="text-muted-foreground hover:text-foreground"><X size={18} /></button>
        </div>
        <p className="text-[13px] text-muted-foreground mb-4">Blocked companies and domains are never shown in results or included in exports/pushes.</p>

        <div className="flex gap-2">
          <div className="flex rounded-lg border border-border overflow-hidden">
            <button onClick={() => setType("company")} className={`px-3 py-2 text-[13px] font-medium inline-flex items-center gap-1 ${type === "company" ? "bg-foreground text-white" : "text-muted-foreground"}`}><Building2 size={13} /> Company</button>
            <button onClick={() => setType("domain")} className={`px-3 py-2 text-[13px] font-medium inline-flex items-center gap-1 ${type === "domain" ? "bg-foreground text-white" : "text-muted-foreground"}`}><Globe size={13} /> Domain</button>
          </div>
          <input value={value} onChange={(e) => setValue(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()}
            placeholder={type === "company" ? "Company name (e.g. Acme Plumbing)" : "domain.com"}
            className="flex-1 border border-border rounded-lg px-3 py-2 text-[14px] outline-none focus:border-brand-500" />
          <button onClick={add} className="inline-flex items-center gap-1 px-3 py-2 rounded-lg bg-brand-600 text-white text-[14px] font-medium hover:bg-brand-700"><Plus size={15} /></button>
        </div>

        <div className="mt-5 max-h-64 overflow-y-auto">
          {items.length === 0 ? (
            <p className="text-[13px] text-muted-foreground text-center py-6">Nothing blocked yet.</p>
          ) : (
            <div className="space-y-2">
              {items.map((it) => (
                <div key={it.id} className="flex items-center justify-between rounded-lg border border-border px-3 py-2">
                  <span className="inline-flex items-center gap-2 text-[13px] text-foreground">
                    {it.type === "domain" ? <Globe size={13} className="text-muted-foreground" /> : <Building2 size={13} className="text-muted-foreground" />}
                    {it.value}
                    <span className="text-[11px] text-muted-foreground bg-secondary px-1.5 py-0.5 rounded">{it.type}</span>
                  </span>
                  <button onClick={() => remove(it.id)} className="text-muted-foreground/50 hover:text-red-500"><Trash2 size={15} /></button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
